import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, IconButton, CircularProgress, RaisedButton, TextField } from 'material-ui';
import pluralize from 'pluralize';
import AttachFile from 'material-ui/svg-icons/editor/attach-file';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import SearchIcon from 'material-ui/svg-icons/action/search';
import AddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import {
  searchContractRequest as searchContractRequestAction,
  createContractWithFiles as createContractWithFilesAction,
  addFilesToRequestsInDialog as addFilesToRequestsInDialogAction,
  getPartners as getPartnersAction,
} from '../../messagingStore/messaging-actions';
import R from 'ramda';
import ContractInfoForm from './contractInfoForm';
import MatchedRequests from './matchedRequests';
import CongratulationPage from './congratulation';
import RaisedButtonWithLoader from '../../../tc-ui/raised-button-with-loader';

const mapStateToProps = ({ messaging, user }) => ({
  ...messaging.actionDialog.toJS(),
  buyerCompanyName: user.getIn(['company', 'companyName']),
  buyerId: user.getIn(['company', 'companyId']),
});
const mapDispatchToProps = ({
  createContractWithFiles: createContractWithFilesAction,
  searchContractRequest: searchContractRequestAction,
  addFilesToRequestsInDialog: addFilesToRequestsInDialogAction,
  getPartners: getPartnersAction,
});
const propTypes = {
  open: PropTypes.bool,
  searchingRequests: PropTypes.bool,
  showRequests: PropTypes.bool,
  files: PropTypes.array,
  updateProps: PropTypes.func,
  startDateValue: PropTypes.string,
  endDateValue: PropTypes.string,
  msg: PropTypes.object,
  companyNameValue: PropTypes.string,
  createContractWithFiles: PropTypes.func,
  searchContractRequest: PropTypes.func,
  createdContract: PropTypes.object,
  updatedContract: PropTypes.object,
  creatingContract: PropTypes.bool,
  buyerCompanyName: PropTypes.string,
  buyerId: PropTypes.string,
  newPartner: PropTypes.object,
  selectedPartner: PropTypes.object,
  matchedRequestsByEmails: PropTypes.array,
  partners: PropTypes.array,
  loadingRequests: PropTypes.bool,
  addFilesToRequestsInDialog: PropTypes.func,
  searchedForRequests: PropTypes.bool,
  allEmailsFromBody: PropTypes.array,
  getPartners: PropTypes.func,
  showNewPartnerForm: PropTypes.bool,
};
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

/*
 step 1:
  show requests that we matched based on the emails we pull from the email body
  if no requests, ask user
  option one: search based on user inputs
  option two: create a new contract request

 */
class MessagingActionDialog extends React.Component {
  constructor() {
    super();
    this.state = {
      allEmailsFromBody: [],
      step: 'showOptions', // showOptions, searchRequests, createNewRequest
      searchInput: '',
      doSearchByInput: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      const {
        msg,
        startDateValue,
        endDateValue,
        searchContractRequest,
        getPartners,
        updateProps,
      } = nextProps;
      const allEmailsFromBody = R.call(R.compose(
        R.reject(R.contains('staging.tourconnect.com')),
        R.uniq,
        R.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi)
      ), msg.bodyText);
      updateProps('action_dialog', { allEmailsFromBody });
      searchContractRequest({
        companyId: this.props.buyerId,
        companyType: 'Contractor',
        startDate: startDateValue,
        endDate: endDateValue,
        emails: nextProps.newPartner.email ? R.uniq(R.append(nextProps.newPartner.email, allEmailsFromBody)) : allEmailsFromBody,
      });
      getPartners();
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  chooseSearchRequests = () => {
    this.setState({ step: 'searchRequests' });
  }
  searchRequestsByInput = () => {
    this.setState({ doSearchByInput: true });
    this.props.searchContractRequest({
      companyId: this.props.buyerId,
      companyType: 'Contractor',
      startDate: this.props.startDateValue,
      endDate: this.props.endDateValue,
      searchInput: this.state.searchInput,
    });
  };
  render() {
    const {
      open,
      searchingRequests,
      showRequests,
      files,
      updateProps,
      matchedRequestsByEmails,
      matchedRequestsByInput,
      createdContract,
      updatedContract,
      addFilesToRequestsInDialog,
      startDateValue,
      endDateValue,
      newPartner,
      selectedPartner,
      createContractWithFiles,
      msg,
      buyerCompanyName,
      buyerId,
      allEmailsFromBody,
    } = this.props;
    const createContractWithFilesFn = () => createContractWithFiles({
      messageId: msg.messageId,
      buyerCompanyName,
      buyerId,
      startDate: startDateValue,
      endDate: endDateValue,
      files: R.map(R.compose(
        R.assoc('source', 'emailScrape'),
        R.omit(['logs'])
      ), files),
      newPartner,
      selectedPartner,
    });
    if (!open) return <div/>;
    const { step } = this.state;
    const searchOrCreateButtonsNode = (
      <div className="flex-tc-sb" style={{ marginTop: '16px', width: '80%' }}>
        <RaisedButton
          secondary
          icon={<SearchIcon/>}
          label="Search Existing Requests"
          onTouchTap={this.chooseSearchRequests}
        />
        <div>OR</div>
        <RaisedButton
          secondary
          icon={<AddIcon/>}
          label={`Add ${pluralize('File', files.length)} to A New Contract`}
          onTouchTap={() => this.setState({ step: 'createNewRequest' })}
        />
      </div>);
    return (
      <Dialog
        open={open}
        autoScrollBodyContent
        modal
        bodyStyle={{ padding: '24px' }}
        titleStyle={{ padding: '8px 16px' }}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Add {pluralize('File', files.length)} to Contract
            <IconButton
              iconClassName="tc-icon-close"
              iconStyle={{ color: 'red', fontSize: '32px' }}
              onTouchTap={() => {
                updateProps('action_dialog', { open: false });
              }}
            />
          </div>
        }
        actions={<div className="flex-tc-sb">
          <div style={{ textAlign: 'left' }}>
            Selected {pluralize('File', files.length)}:
            {
              files.map((file, i) => (<div key={i} style={{ display: 'flex', alignItems: 'center' }}>
                <AttachFile style={{ height: '16px', color: 'grey' }}/>
                <span style={{ maxWidth: '380px', overflowX: 'hidden', textOverflow: 'ellipsis' }}>
                  {file.name}
                </span>
              </div>))
            }
          </div>
          {
            R.call(R.cond([
              [() => searchingRequests, R.always(<span/>)],
              [() => !R.isEmpty(createdContract) || !R.isEmpty(updatedContract), R.always(<span/>)],
              [() => step === 'showOptions', R.always(<span/>)],
              [R.T, R.always(
                <div>
                  <RaisedButton
                    label="Back"
                    onTouchTap={() => this.setState({ step: 'showOptions' })}
                    icon={<ArrowBack/>}
                  />
                  {
                    step === 'searchRequests' ? (
                      <RaisedButtonWithLoader
                        secondary
                        style={{ marginLeft: '4px' }}
                        label="Search"
                        loader={searchingRequests}
                        icon={<SearchIcon/>}
                        disabled={!(this.state.searchInput.trim())}
                        onTouchTap={this.searchRequestsByInput}
                      />
                    ) : (
                      <RaisedButtonWithLoader
                        secondary
                        style={{ marginLeft: '4px' }}
                        label="Create New Contract"
                        loader={this.props.creatingContract}
                        icon={<AddIcon/>}
                        disabled={
                          !startDateValue
                          || !endDateValue
                          || startDateValue >= endDateValue
                          || !(
                            (newPartner.email && newPartner.companyName)
                            || (selectedPartner.partnerId && selectedPartner.contactIds.length)
                          )
                        }
                        onTouchTap={createContractWithFilesFn}
                      />
                    )
                  }
                </div>
              )],
            ]))
          }
        </div>}
      >
        {
          R.call(R.cond([
            [() => searchingRequests, R.always(<div style={{ display: 'flex', alignItems: 'center' }}>
              <CircularProgress/>Searching existing requests...
            </div>)],
            [() => !R.isEmpty(createdContract) || !R.isEmpty(updatedContract), R.always(
              <CongratulationPage
                router={this.context.router}
                createdContract={createdContract}
                updateProps={updateProps}
                files={files}
              />
            )],
            [() => step === 'showOptions', R.always(
              <div>
                {
                  !isNilOrEmpty(matchedRequestsByEmails) ? (
                    <div>
                      <MatchedRequests
                        addFilesToRequestsInDialog={addFilesToRequestsInDialog}
                        matchedRequests={matchedRequestsByEmails}
                        files={files}
                      />
                      <br/>
                      Don't see the one you are looking for?
                    </div>
                  ) : (
                    <div>
                      We couldn't find any contracts based on the information from the message.
                      <br/> Would you like to:
                    </div>
                  )
                }
                {searchOrCreateButtonsNode}
              </div>
              )],
            [() => this.state.step === 'searchRequests', R.always(
              <div>
                <label><b>Please enter your partner's information.</b></label>
                <TextField
                  id="companyNameOrEmail"
                  style={{ width: '100%' }}
                  hintStyle={{ fontSize: '12px' }}
                  inputStyle={{ fontSize: '14px' }}
                  hintText="Enter company name or email here..."
                  underlineStyle={{ borderColor: '#00bcd4' }}
                  value={this.state.searchInput}
                  onKeyDown={e => {
                    if (e.keyCode === 13) this.searchRequestsByInput();
                  }}
                  onChange={(_, val) => this.setState({ searchInput: val })}
                />
                {
                  !isNilOrEmpty(matchedRequestsByInput) && this.state.doSearchByInput && (
                    <MatchedRequests
                      addFilesToRequestsInDialog={addFilesToRequestsInDialog}
                      matchedRequests={matchedRequestsByInput}
                      files={files}
                    />
                  )
                }
              </div>
            )],
            [() => this.state.step === 'createNewRequest', R.always(<ContractInfoForm
              {...this.props}
              allEmailsFromBody={allEmailsFromBody}
            />)],
          ]))
        }
      </Dialog>
    );
  }
}
MessagingActionDialog.propTypes = propTypes;
MessagingActionDialog.contextTypes = ({
  router: React.PropTypes.object.isRequired,
});
export default connect(mapStateToProps, mapDispatchToProps)(MessagingActionDialog);



// WEBPACK FOOTER //
// ./src/app/components/messaging/singleConv/dialog/actionDialog.jsx